import { baseService, GLOBAL_TAG_TYPES } from '@repo/services';
import { normalizedResponseSelector } from '@repo/utils';
import { ApiUtils, CaseUtil } from '@vectord/utils';
import { type RecentChatMessage } from 'chat/types/message';

interface GetRecentMessagePayload {
  limit: number;
  offset: number;
}

export const recentMessagesService = baseService.injectEndpoints({
  endpoints: (builder) => ({
    getRecentMessages: builder.infiniteQuery<RecentChatMessage[], void, GetRecentMessagePayload>({
      infiniteQueryOptions: {
        initialPageParam: {
          limit: 30,
          offset: 0,
        },
        getNextPageParam(_, allPages, firstPageParam) {
          if (allPages[allPages.length - 1]?.length === 0) return undefined;

          return {
            limit: firstPageParam.limit,
            offset: allPages.length * firstPageParam.limit,
          };
        },
      },
      query: ({ pageParam: { limit, offset } }) => ({
        url: `v1/whatsapp/messages/recents?limit=${limit}&offset=${offset}`,
        method: 'GET',
      }),
      transformResponse: (response: any) => {
        if (!response.data) return [];
        const preNormalized = ApiUtils.normalizeJsonApiResponse(response);
        const normalizedResponse = normalizedResponseSelector(preNormalized.data, preNormalized.associations);
        const caseNormalizedResponse = CaseUtil.toCase('camelCase', normalizedResponse);
        return caseNormalizedResponse as RecentChatMessage[];
      },
      providesTags: [GLOBAL_TAG_TYPES.recentLeadChatMessagesForUser],
    }),
  }),
});

export const {
  useGetRecentMessagesInfiniteQuery,
} = recentMessagesService;
